import { VideoChatStateKeys } from '@/enums/VideoChatStateKeys'
// state
const initState = () => {
  return {
    view: 'HOME',
    showChat: false,
    home_tab: 'PRIVATE',
    active_chats: [],
    private_channels: {},
    active_channel: null,
    public_channel: null,
    // Donovann
    parrent_thread: null,
    thread_has_chat: false,
    // End Donovann
    talking_to: {},
    video_chat: {
      user_uuid: '',
      target_user: {},
      target_user_uuid: '',
      room_uuids: null,
      iframe_modal: false,
      status: VideoChatStateKeys.not_started, //not_started | on_going | ringing | waiting | declined
    },
  }
}

// getters
const getters = {}

// actions
const actions = {
  closeCall({ commit }) {
    commit('setVideoChat', {
      user_uuid: '',
      target_user: {},
      target_user_uuid: '',
      room_uuids: null,
      iframe_modal: false,
      status: VideoChatStateKeys.not_started,
    })
  },
  answerCall({ commit }) {
    commit('setVideoChat', {
      status: VideoChatStateKeys.on_going,
    })
  },
  hungUp({ commit }) {
    commit('setVideoChat', {
      status: VideoChatStateKeys.hung_up,
    })
  },
  targetBusy({ commit }) {
    commit('setVideoChat', {
      status: VideoChatStateKeys.busy,
    })
  },
  declined({ commit }) {
    commit('setVideoChat', {
      status: VideoChatStateKeys.declined,
    })
  },
  isRinging({ commit }, { body }) {
    // Caller identity comes from the call signal payload (SignalCallController),
    // not socket.users — so an inbound call from an attendee who isn't on the
    // loaded roster page still rings and connects (users-list-plan.md §4.7a).
    const target_user = body.caller || {}
    // Prefer the caller-authoritative room id from the signal so both peers use the
    // exact same id regardless of how each derives it (kills any mixed-version room
    // mismatch). Fall back to deriving it (uuid-sorted) for older callers.
    const room_uuids =
      body.room_uuids || [body.user_uuid, body.target_user_uuid].sort().join('-link-')
    commit('setVideoChat', {
      target_user,
      target_user_uuid: body.target_user_uuid,
      user_uuid: body.user_uuid,
      room_uuids,
      status: VideoChatStateKeys.ringing,
      iframe_modal: true,
    })
  },
  callUser({ commit }, { body }) {
    commit('setVideoChat', {
      target_user: body.target_user,
      target_user_uuid: body.target_user_uuid,
      user_uuid: body.user_uuid,
      room_uuids: body.uuids,
      status: VideoChatStateKeys.waiting,
      iframe_modal: true,
    })
  },
}

// mutations
const mutations = {
  setVideoChat(state, obj) {
    Object.keys(obj).forEach((k) => (state.video_chat[k] = obj[k]))
  },
  setState(state, obj) {
    Object.keys(obj).forEach((k) => (state[k] = obj[k]))
  },
}

export const Chat = {
  namespaced: true,
  state: initState,
  getters,
  actions,
  mutations,
}
